export default __webpack_public_path__ + "static/media/awscommunitybuilder.ee8015f1.png";